import { Star } from "lucide-react";

export function StarRating({ value = 0, onChange, size = 16, readOnly = false, testId = "stars" }) {
  return (
    <div data-testid={testId} className="inline-flex items-center gap-0.5">
      {[1, 2, 3, 4, 5].map((n) => {
        const filled = n <= Math.round(value);
        return (
          <button
            key={n}
            type="button"
            disabled={readOnly}
            onClick={() => !readOnly && onChange?.(n)}
            data-testid={`${testId}-${n}`}
            className={readOnly ? "cursor-default" : "cursor-pointer hover:scale-110 transition-transform"}
          >
            <Star
              style={{ width: size, height: size }}
              className={filled ? "fill-[#D67B54] text-[#D67B54]" : "text-[#E2DFD8]"}
            />
          </button>
        );
      })}
    </div>
  );
}
